module.exports = __webpack_public_path__ + "img/no_data_img.833ec458.png";